export default "__VITE_ASSET__73361245__"